import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import NewQuery from "@/pages/NewQuery";
import Report from "@/pages/Report";
import Reports from "@/pages/Reports";
import Ledger from "@/pages/Ledger";

function Protected({ children }) {
  const { user, checked } = useAuth();
  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50">
        <div className="text-xs font-mono uppercase tracking-widest text-zinc-400 animate-pulse">Certy Trace · Caricamento…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, checked } = useAuth();
  if (!checked) return null;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
              <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
              <Route path="/app" element={<Protected><Dashboard /></Protected>} />
              <Route path="/app/new" element={<Protected><NewQuery /></Protected>} />
              <Route path="/app/reports" element={<Protected><Reports /></Protected>} />
              <Route path="/app/report/:id" element={<Protected><Report /></Protected>} />
              <Route path="/app/ledger" element={<Protected><Ledger /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
